import { Button, styled } from "@mui/material";


export const OrangePrimaryButton = styled(Button)(({ theme, variant, size }) => ({
  borderRadius: theme.spacing(4),
  paddingBlock: theme.spacing(1),
  paddingInline: theme.spacing(3),
  ...(size === 'small' && {
    paddingBlock: theme.spacing(0.5),
    paddingInline: theme.spacing(1),
  }),
  ...(variant === 'contained' && {
    backgroundColor: theme.palette.secondary[400],
    color: theme.palette.common.white,
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: `${theme.palette.secondary[500]} !important`,
    },
    '&:disabled': {
      backgroundColor: theme.palette.secondary[200],
      color: theme.palette.grey[500],
    },
    '&.MuiButtonGroup-firstButton': {
      borderColor: theme.palette.secondary[900],
      boxShadow: 'none',
    }
  }),
  ...(variant === 'outlined' && {
    backgroundColor: 'inherit',
    color: theme.palette.secondary[400],
    borderColor: theme.palette.secondary[400],
    '&:hover': {
      backgroundColor: theme.palette.secondary[50]
    },
    '&:disabled': {
      backgroundColor: theme.palette.secondary[200],
      color: theme.palette.grey[500],
    },
    '&.MuiButtonGroup-firstButton': {
      borderColor: theme.palette.secondary[400],
      boxShadow: 'none',
    }
  }),

}));


/*
export const OrangePrimaryButton = styled(Button)(({ theme, variant, size }) => ({
  borderRadius: theme.spacing(4),
  paddingBlock: theme.spacing(1),
  paddingInline: theme.spacing(3),
  ...(size === 'small' && {
    paddingBlock: theme.spacing(0.5),
    paddingInline: theme.spacing(1),
  }),
  ...(variant === 'contained' && {
    backgroundColor: theme.palette.secondary[400],
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: `${theme.palette.secondary[500]} !important`,
    },
    '&:disabled': {
      backgroundColor: theme.palette.secondary[200],
      color: theme.palette.grey[500],
    },
  }),
  ...(variant === 'outlined' && {
    backgroundColor: 'inherit',
    color: theme.palette.secondary[400],
    borderColor: theme.palette.secondary[400],
    '&:hover': {
      backgroundColor: theme.palette.background.dark[500]
    },
    '&:disabled': {
      backgroundColor: theme.palette.secondary[200],
      color: theme.palette.grey[500],
    },
    '&.MuiButtonGroup-firstButton': {
      borderColor: theme.palette.primary[400]
    }
  }),
}));
*/